import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {environment} from "../environments/environment";
import {cookieGuard} from "./core/guards/check-application-cookie.guard";
import {displayGuard} from "./core/guards/check-is-display.guard";
import {DisplayStateService} from "./modules/display/display-state.service";
import {Theme} from "@common/types/Theme";

const routes: Routes = [
	{
		path: environment.routes.login,
		loadChildren: () => import("./modules/login/login.module").then((m) => m.LoginModule),
	},
	{
		path: "testing",
		data: {
			theme: Theme.dark,
		},
		loadChildren: () => import("./modules/_testing/testing.module").then((m) => m.TestingModule),
		canMatch: [() => !environment.production],
	},
	{
		path: environment.routes.error,
		loadChildren: () => import("./modules/error/error.module").then((m) => m.ErrorModule),
	},
	{
		path: environment.routes.autoLogin,
		loadChildren: () => import("./modules/auto-login/auto-login.module").then((m) => m.AutoLoginModule),
	},
	{
		path: environment.routes.deviceRegistration,
		loadChildren: () => import("./modules/device-registration/device-registration.module").then((m) => m.DeviceRegistrationModule),
		canActivateChild: [cookieGuard],
	},
	{
		path: environment.routes.simDebriefingPlayer,
		redirectTo: environment.routes.simPlayer,
	},
	{
		path: "",
		canActivateChild: [cookieGuard],
		children: [
			{
				path: environment.routes.eventDashboard,
				loadChildren: () => import("./modules/session-dashboard/session-dashboard.module").then((m) => m.SessionDashboardModule),
			},
			{
				path: environment.routes.sessionSelection,
				loadChildren: () => import("./modules/session-selection/session-selection.module").then((m) => m.SessionSelectionModule),
			},
			{
				path: environment.routes.roomPlanner,
				loadChildren: () => import("./modules/sim-room-planner/sim-room-planner.module").then((m) => m.SimRoomPlannerModule),
			},
			{
				path: environment.routes.stageDesigner,
				loadChildren: () => import("./modules/sim-stage-designer/sim-stage-designer.module").then((m) => m.SimStageDesignerModule),
			},
			{
				path: environment.routes.simrecorder,
				loadChildren: () => import("./modules/sim-recorder/sim-recorder.module").then((m) => m.SimRecorderModule),
			},
			{
				path: environment.routes.eventDetail,
				loadChildren: () => import("./modules/event-detail/event-detail.module").then((m) => m.EventDetailModule),
			},
			{
				path: environment.routes.simPlayer,
				loadChildren: () => import("./modules/sim-player/sim-player.module").then((m) => m.SimPlayerModule),
			},
			{
				path: "display",
				loadChildren: () => import("./modules/display/display.module").then((m) => m.DisplayModule),
				canActivateChild: [displayGuard],
				providers: [DisplayStateService],
			},
			{
				path: "sim-debriefing-tablet",
				loadChildren: () =>
					import("./modules/sim-debriefing-tablet/sim-debriefing-tablet.module").then((m) => m.SimDebriefingTabletModule),
			},
			{
				path: environment.routes.debriefing,
				loadChildren: () =>
					import("./modules/debriefing-selection/debriefing-selection.module").then((m) => m.DebriefingSelectionModule),
			},
			{
				path: environment.routes.liveView,
				loadChildren: () => import("./modules/sim-live-view/sim-live-view.module").then((m) => m.SimLiveViewModule),
			},
			{
				path: environment.routes.presentation,
				loadChildren: () => import("./modules/sim-presentation/sim-presentation.module").then((m) => m.SimPresentationModule),
			},
			{
				path: environment.routes.participationView,
				loadChildren: () => import("./modules/join-training/join-training.module").then((m) => m.JoinTrainingModule),
			},
			{
				path: environment.routes.cameraViewer,
				loadChildren: () => import("./modules/camera-view/camera-view.module").then((m) => m.CameraViewModule),
			},
			{
				path: environment.routes.healthMonitor,
				loadChildren: () => import("./modules/health-monitor/health-monitor.module").then((m) => m.HealthMonitorModule),
			},
			{
				path: environment.routes.participantDevice,
				loadChildren: () =>
					import("./modules/applications/participant-devices/participant-devices.module").then((m) => m.ParticipantDevicesModule),
			},
			{
				path: environment.routes.confirmationApp,
				loadChildren: () =>
					import("./modules/applications/confirmation-app/confirmation-app.module").then((m) => m.ConfirmationAppModule),
			},
			{
				path: environment.routes.masterOfCeremonyApp,
				loadChildren: () =>
					import("./modules/applications/master-of-ceremony-app/master-of-ceremony-app.module").then(
						(m) => m.MasterOfCeremonyAppModule,
					),
			},
			{
				path: environment.routes.peerPracticeStudentApp,
				loadChildren: () =>
					import("./modules/applications/peer-practice-student-app/peer-practice-student-app.module").then(
						(m) => m.PeerPracticeStudentAppModule,
					),
			},
			{
				path: environment.routes.webManager,
				loadChildren: () => import("./modules/web-manager/web-manager.module").then((m) => m.WebManagerModule),
			},
			{
				path: environment.routes.groupManager,
				loadChildren: () => import("./modules/group-manager/group-manager.module").then((m) => m.GroupManagerModule),
			},
			{
				path: environment.routes.cctv,
				loadChildren: () => import("./modules/cctv/cctv.module").then((m) => m.CctvModule),
			},
			{
				path: "**",
				redirectTo: environment.routes.eventDashboard,
				pathMatch: "full",
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
